import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import PageSection from '../../PageSection'
import BigBarGraph from '../../Graphs/BigBarGraph'

import { capitalizeFirstLetter } from '../../../../helpers/common'
import { getReusableTooltipCallbackOptions } from '../helpers'

import { GRAPH_COLOR_3 } from '../../../../styles/themes/getDefaultTheme'

import useStyles from '../styles'

const GenderGraphSection = ({ rawGraphData, showAdvancedMetrics, currencySymbol }) => {
  const classes = useStyles()

  const theme = useTheme()

  const genderGraphData = useMemo(() => rawGraphData && rawGraphData.map(data => data.impressions), [rawGraphData])
  const genderGraphLabels = useMemo(
    () => rawGraphData && rawGraphData.map(data => capitalizeFirstLetter(data.breakdown)),
    [rawGraphData]
  )

  const tooltipCallbackOptions = useMemo(
    () => getReusableTooltipCallbackOptions({ rawGraphData, showAdvancedMetrics, currencySymbol }),
    [rawGraphData, showAdvancedMetrics, currencySymbol]
  )

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>Gender</div>
      </div>
      <BigBarGraph
        className={classes.graphWrapper}
        data={genderGraphData}
        labels={genderGraphLabels}
        graphColor={theme[GRAPH_COLOR_3]}
        format="integer"
        tooltipCallbackOptions={tooltipCallbackOptions}
      />
    </PageSection>
  )
}

GenderGraphSection.propTypes = {
  rawGraphData: PropTypes.array.isRequired,
  showAdvancedMetrics: PropTypes.bool,
  currencySymbol: PropTypes.string
}

export default GenderGraphSection
